<template>
  <div class="flex items-center gap-1">
    <template v-if="count > 0">
      <div
        v-for="i in visible"
        :key="i"
        class="flex h-9 w-[27px] items-center justify-center overflow-hidden rounded border border-border bg-muted text-muted-foreground"
      >
        <svg-icon name="huge-user" class="h-3.5 w-3.5 opacity-50" />
      </div>
      <div
        v-if="extra > 0"
        class="flex h-9 min-w-[27px] items-center justify-center overflow-hidden rounded border border-border bg-muted px-1 text-[10.5px] font-medium text-muted-foreground"
      >
        +{{ extra }}
      </div>
    </template>
    <template v-else>
      <div
        class="flex h-9 w-[27px] items-center justify-center overflow-hidden rounded border border-dashed border-border bg-muted/40 text-muted-foreground"
      >
        <svg-icon name="huge-user" class="h-3.5 w-3.5 opacity-40" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "FaceThumbsCell",
  props: {
    count: { type: Number, default: 0 },
    seed: { type: String, default: "" },
    gender: { type: String, default: null },
  },
  computed: {
    visible() {
      return Math.min(this.count, 3);
    },
    extra() {
      return Math.max(0, this.count - 3);
    },
  },
};
</script>
